import { render, staticRenderFns } from "./ContactSchool.vue?vue&type=template&id=4c502b1a"
import script from "./ContactSchool.vue?vue&type=script&lang=js"
export * from "./ContactSchool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports